import React from 'react'
import PropTypes from 'prop-types'

function Picture({ src, webp, alt, className }) {
    if (typeof src === 'object' && src.default) {
        src = src.default
    }
    if (typeof webp === 'object' && webp.default) {
        webp = webp.default
    }

    return (
        <picture className={className}>
            {webp && <source srcSet={webp} type="image/webp" />}
            <img src={src} alt={alt} />
        </picture>
    );
}

Picture.defaultProps = {
    alt: '',
}

Picture.propTypes = {
    src: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
}

export default Picture;
